import React from "react";
import {Routes, Route, Outlet} from "react-router-dom";

import {CustomerProvider} from "../context/CustomerContext";

import AdditionalData from "../Customer/AdditionalData";
import BookSlot from "../Customer/BookSlot";
import CancelAppointments from "../Customer/CancelAppointments";
import ConfirmBooking from "../Customer/ConfirmBooking";
import CurrentAttention from "../Customer/CurrentAttention";
import CurrentBooking from "../Customer/CurrentBooking";
import CustomerIndex from "../Customer";
import DisplayAppointments from "../Customer/DisplayAppointments";
import DisplayTurnero from "../Customer/DisplayTurnero";
import FAQ from "../Customer/FAQ";
import GuestLandingPage from "../Customer/GuestLandingPage";
import LoggedInLandingPage from "../Customer/LoggedInLandingPage";
import NotFound from "../components/NotFound";
// import OfficeQuestions from "../Customer/OfficeQuestions";
import QueueBooked from "../Customer/QueueBooked";
import SelectMallStore from "../Customer/SelectMallStore";
import SelectStore from "../Customer/SelectStore";
import SelectTurneroStoreAndType from "../Customer/SelectTurneroStoreAndType";
import SlotBooked from "../Customer/SlotBooked";
import {CleveronScreen} from "../components/CleveronScreen";
import CustomerInfo from "../Customer/CustomerInfo";

function Customer() {
  return (
    <CustomerProvider>
      <Outlet />
    </CustomerProvider>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="customer" element={<Customer />}>
        <Route path="" element={<CustomerIndex />} />
        <Route path="additionalData" element={<AdditionalData />} />
        <Route path="bookQueue" element={<QueueBooked />} />
        <Route path="bookSlot" element={<BookSlot />} />
        <Route path="cancelAppointments" element={<CancelAppointments />} />
        <Route path="confirmBooking" element={<ConfirmBooking />} />
        <Route path="currentattention" element={<CurrentAttention />} />
        <Route path="currentBooking" element={<CurrentBooking />} />
        <Route path="displayAppointments" element={<DisplayAppointments />} />
        <Route path="displayTurnero" element={<DisplayTurnero />} />
        <Route path="faq" element={<FAQ />} />
        <Route path="guestLandingPage" element={<GuestLandingPage />} />
        <Route path="loggedInLandingPage" element={<LoggedInLandingPage />} />
        {/* <Route path="officeQuestions" element={<OfficeQuestions />} /> */}
        <Route path="selectMallStore" element={<SelectMallStore />} />
        <Route path="selectStore" element={<SelectStore />} />
        <Route path="customerInfo" element={<CustomerInfo />} />
        <Route
          path="selectTurneroStoreAndType"
          element={<SelectTurneroStoreAndType />}
        />
        <Route path="slotBooked" element={<SlotBooked />} />
      </Route>
      <Route path="cleveronScreen" element={<CleveronScreen />}></Route>
      <Route path="*" element={<NotFound />}></Route>
    </Routes>
  );
}
